import { createCspViolationReporter } from '@/service/csp/createCspViolationReporter';
import { createUnsampledLogger } from '@/util/logger/createUnsampledLogger';

angular.module('inspinia').factory('cspViolationReportService', function () {
  return {
    start: createCspViolationReporter(document, createUnsampledLogger()),
  };
});
